export default (() => {
  const queue = []

  const enqueue = task => {
    queue.push(task)
  }

  const dequeue = () => {
    return queue.shift()
  }

  return {
    enqueue,
    dequeue,
  }
})()
